import BigNumber from 'bignumber.js'
import {AppConfig} from "../config";

BigNumber.config({
    EXPONENTIAL_AT: 1000,
    DECIMAL_PLACES: 80,
});


export const getFarms = (sushi) => {

    return sushi
        ? sushi.contracts.pools.map(
            ({
                 name,
                 symbol,
                 icon,
                 tokenSymbol,
                 lpAddress,
                 lpContract,
                 contractAddresses,
                 sC,
                 vesting,
                tsl,
                 premium
             }) => {
                return {
                    id: symbol,
                    name,
                    lpToken: symbol,
                    lpTokenAddress: lpAddress,
                    lpContract,
                    tokenSymbol,
                    icon,
                    contractAddresses,
                    earnToken: 'NSure',
                    vesting,
                    sC,
                    tsl:AppConfig.allTsl[symbol],
                    raf:AppConfig.allRAF[symbol]
                };
            },
        )
        : []
};


// export const redeem = async (masterChefContract, account) => {
//     let now = new Date().getTime() / 1000;
//     if (now >= 1597172400) {
//         return masterChefContract.methods
//             .exit()
//             .send({from: account})
//             .on('transactionHash', (tx) => {
//                 console.log(tx);
//                 return tx.transactionHash
//             })
//     } else {
//         alert('pool not active')
//     }
// };
